import { Button, Result, Typography, theme } from 'antd';
import { FC, memo } from 'react';
import { SignDoNotEnterFill, XCircleFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { QueryError } from '@/common/interfaces';

const { Paragraph, Text } = Typography;

interface Props {
  error: QueryError | null;
  withReload?: boolean;
  size?: 'small' | 'default';
}

export const ErrorAlert: FC<Props> = memo(({ error, withReload = true, size = 'default' }) => {
  const navigate = useNavigate();
  const {
    token: { colorError },
  } = theme.useToken();

  const apiErrorResponse = error?.response?.data;
  const apiErrorMessage = apiErrorResponse
    ? Array.isArray(apiErrorResponse.message)
      ? apiErrorResponse.message[0].errors[0]
      : apiErrorResponse.message
    : error?.message;

  const handleReloadPage = (): void => {
    navigate(0);
  };

  if (error?.response?.status === 403) {
    return (
      <Result
        status="error"
        title="Доступ заборонено"
        icon={<SignDoNotEnterFill size={size === 'small' ? 56 : 70} color={colorError} />}
        subTitle="У вас немає дозволу на перегляд цього ресурсу."
        style={size === 'small' ? { padding: 10 } : undefined}
      />
    );
  }

  return (
    <Result
      status="error"
      title="Запит виконався з помилкою"
      icon={<XCircleFill size={size === 'small' ? 56 : 70} color={colorError} />}
      subTitle={size === 'small' ? apiErrorMessage : undefined}
      extra={
        withReload
          ? [
              <Button key="reload" onClick={handleReloadPage}>
                Спробувати ще раз
              </Button>,
            ]
          : null
      }
      style={size === 'small' ? { padding: 10 } : undefined}
    >
      {size !== 'small' && !!apiErrorResponse && (
        <div>
          <Paragraph>
            <Text
              strong
              style={{
                fontSize: 16,
              }}
            >
              Сталася така помилка:
            </Text>
          </Paragraph>
          <Paragraph>{apiErrorMessage}</Paragraph>
        </div>
      )}
    </Result>
  );
});
